import { Link } from 'react-router-dom'
import { Button } from './ui/button'

export default function Navigation() {
  return (
    <nav className="relative z-10 border-b border-white/10">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/welcome" className="flex items-center space-x-2">
          <div className="h-8 w-8 bg-gradient-to-br from-orange-500 to-purple-600 rounded-lg" />
          <span className="text-white font-semibold">Starter Kit</span>
        </Link>
        <div className="flex items-center space-x-4">
          <Link to="/welcome">
            <Button variant="ghost" className="text-white/80 hover:text-white">
              Home
            </Button>
          </Link>
          <Link to="/legal">
            <Button variant="ghost" className="text-white/80 hover:text-white">
              Legal
            </Button>
          </Link>
        </div>
      </div>
    </nav>
  )
} 